import config from "@/config";

const CRUDMixin = {
    data() {
        return {
            options: {
                page : 1,
                itemsPerPage : config.fetchCount
            },
            total : 0,
            footerProps: {'items-per-page-options': [5, 10, 15, 30, 50, 100]}
        }
    },
    watch: {
        '$route'(){
            this.fetch();
        },
    },
    mounted() {
        this.initalizeList();
        this.fetch();
    },
    methods : {
        initalizeList(){
            this.initalizePageParams();
            this.$watch('options', {
                handler (newOptions) {
                    this.replaceRoute({
                        page : newOptions.page,
                        count : newOptions.itemsPerPage
                    });
                },
                deep: true,
            });
        },
        replaceRoute(routeParams){
            let query = {...this.$route.query, ...routeParams};
            this.$router.replace({ query });
        },
        initalizePageParams(){
            this.options.page = parseInt(this.$route.query.page || this.options.page);
            this.options.itemsPerPage = parseInt(this.$route.query.count || this.options.itemsPerPage);
        },
    }
}

export default CRUDMixin;